import { styled } from '@clickcease/cc-client-components-lib'

export const CheckoutSuccessStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const CheckoutSuccessIconWrapper = styled('div', {
  width: '54px',
  height: '54px',
  background: '$tableHovered',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50px',
  marginTop: '120px',

  variants: {
    isSignUp: {
      true: {
        marginTop: '0',
      },
    },
  },
})

export const CheckoutSuccessTitle = styled('div', {
  marginTop: '$20',
  fontWeight: '$sb',
  fontSize: '24px',
})
export const CheckoutSuccessDescription = styled('div', {
  marginTop: '$12',
  fontSize: '$lg',
  width: '420px',
  textAlign: 'center',
})
